<template>
    <section v-if="hasPermissions(['Report Read', 'Report Write'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1" v-html="title_page"/>
        <div class="view__description">
            <p class="view__description__text">
            </p>
        </div>

        <div class="bar-container-inspections">
            <div class="bar-container-inspections__search-bar">
                <div class="input-field my-0" v-if="daily_assignments.length">
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-model="search">
                </div>
            </div>
            <div class="bar-container-inspections__options">
                <label v-html="`See all rooms`" class="modal-label mb-1" style="display: block; font-size: 13px; color: #212529;"/>
                <div class="custom-control custom-checkbox">
                    <input 
                        type="checkbox" 
                        class="custom-control-input"
                        v-model="see_all_rooms"
                        id="see_all_rooms"
                    />
                    <label
                        class="custom-control-label ml-1"
                        for="see_all_rooms"
                    />
                </div>
            </div>
            <div class="bar-container-inspections__cta">
                <button class="modal__buttons__item w-auto ml-1 ml-md-2 px-3" v-html="`Close`" @click="backToReports()" style="margin-right:8px; float: right;"/>
                <span class="btn-group modal__buttons__item w-auto mr-md-auto ml-sm-2 px-3 ml-md-2">
                    <button type="button" style="border-top-right-radius: 0px; border-bottom-right-radius: 0px; padding-right:15px;" v-html="'Export'" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"/>
                    <button type="button" class="dropdown-toggle dropdown-toggle-split ml-0" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="border-top-left-radius: 0px; border-bottom-left-radius: 0px; padding-right:0px;">
                        <span class="sr-only"/>
                    </button>
                    <div class="dropdown-menu" :style="'font-size: 14px; padding:0; margin-top: 0px;'">
                        <a class="dropdown-item" href="#" v-html="'Export to PDF Portrait'" @click="exportPDF('portrait')"/>
                        <a class="dropdown-item" href="#" v-html="'Export to PDF Landscape'" @click="exportPDF('landscape')"/>
                        <a class="dropdown-item" href="#" v-html="'Export to xlsx'" @click="exportToFormat('xlsx')"/>
                        <a class="dropdown-item" href="#" v-html="'Export to csv'" @click="exportToFormat('csv')"/>
                    </div>
                </span>
            </div>
        </div>
        
        <div class="tab-content" v-for="(item, index) in  daily_assignments" :key="index">
            <div class="tab-pane fade active show" id="listation">
                <div class="row mb-0 no-gutters">
                    <h6 class="mb-4"  v-html="`${item.daily_assignment.number_assigment} - ${item.daily_assignment.description}`" v-if="daily_assignments.length > 1"/>
                    <div class="col-lg-12">
                        <v-card>
                            <DinamicTable
                                :headers="table_headers"
                                :items="item.rooms_assigned"
                                :search="search"
                                :checkable="false"
                                :link="'#'"
                                :selectable_columns="false"
                                ref="dinamic_table"
                            />
                        </v-card>
                    </div>
                </div>
            </div>
        </div>
        <WaitingModal/>
    </section>

    <div v-else>
        <UnauthorizedComponent :breadcrumb="breadcrumb"/>
    </div>

</template>

<script>
import axios        from 'axios';
import Resources    from './resources'
import Breadcrumb   from '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal from '@/components/WaitingModal'
import DinamicTable from '@/components/DinamicTable'
import UnauthorizedComponent from   '@/components/UnauthorizedComponent'
import jsPDF        from 'jspdf'
import autoTable from 'jspdf-autotable'
import { Notyf }    from 'notyf'
import 'vuetify/dist/vuetify.min.css'
import 'notyf/notyf.min.css' // for React and Vue
// import FormResources from './form_resources';
const notyf = new Notyf({
    duration: 8000,
});

export default {

    name: "QuickReportAssociate",

    components: {
        Breadcrumb,
        WaitingModal,
        DinamicTable,
        UnauthorizedComponent,
    },

    data() {
        return {
            notyf,
            axios,
            report_root:        {},
            parent_id:          1,
            daily_assignment_id: this.$route.params.id,
            user:               this.get_user(),
            title_page:         'Reports',
            rest_api:           `search_standard_reports`,
            current_url:        `/reports`,
            table_headers:      [],
            breadcrumb:         JSON.parse(JSON.stringify(Resources.breadcrumb)),
            search:             '',
            array_options:      {},

            json_excel_fields:  {},
            json_pdf_fields:    Resources.quick_report_associate_view,

            company_name: 'Digital Solutions, SE & Associates, Inc.',

            headers_step_codes_table: Resources.headers_step_codes_table,
            base64_logo:            {},
            see_all_rooms: false,
            logo_corporation:  null,
            daily_assignments: []
        };
    },

    methods: {

        backToReports()
        {
            window.location.href = '/reports'
        },

         addWaterMark(doc)
        {
            const total_pages = doc.internal.getNumberOfPages()

            const printWidth = doc.internal.pageSize.width - (10 + 10);

            for (let i = 1; i <= total_pages; i++)
            {
                doc.setPage(i)
                doc.setTextColor(150)
                doc.setFontSize(10);
                // doc.text(this.report_root.full_date, doc.internal.pageSize.width - 160, 28)

                doc.addImage("/assets/img/logo.png", 'png', 40, 28, 120, 40)

                if(this.logo_corporation)
                {
                    doc.addImage(this.logo_corporation.base64, printWidth - this.logo_corporation.width, 10, this.logo_corporation.width, this.logo_corporation.height);
                }

                doc.setTextColor(150)
                doc.setFontSize(9);
                doc.text(40, doc.internal.pageSize.height - 30, this.report_root.name)
                doc.text(doc.internal.pageSize.width - 80, doc.internal.pageSize.height - 30, `${i} of ${total_pages}`)

                let xOffset = (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(this.company_name) * doc.internal.getFontSize() / 2); 
                doc.text(xOffset, doc.internal.pageSize.height - 30, this.company_name)
            }

            return doc
        },

        async exportToFormat(format = 'xlsx')
        {
            if(this.hasPermissions(['Report Read']))
            {
                let daily_assignment_ids = JSON.parse(this.daily_assignment_id)

                if(Array.isArray(daily_assignment_ids) && daily_assignment_ids.length)
                {
                    const form_data = {
                        standard_report_id: this.parent_id,
                        daily_assignment_id: daily_assignment_ids,
                        format: format,
                        see_all_rooms: this.see_all_rooms
                    }

                    this.loader(true)

                    const response = await this.post('search_standard_reports', form_data)

                    this.loader()

                    if(response.status)
                    {
                        this.downloadFile(response)
                    }
                    else
                    {
                        this.error_handling(response)
                    }
                }
                else
                {
                    window.location = '/reports'
                }
            }

        },

        exportPDF(orientation)
        {   
            let PDF_doc = new jsPDF(orientation , 'pt', 'letter')

            autoTable(PDF_doc, {
                columns: [this.report_root.name], 
                body: [],
                startY: 92,
                rowPageBreak: 'avoid',
                styles: {fontSize: 15},
                headStyles:{
                    valign: 'middle',
                    halign : 'center',
                    fillColor : [245, 245, 245],
                    textColor: [70, 70, 71],
                    fontStyle: 'normal',
                }
            })

            this.daily_assignments.forEach((item, index) => 
            {
                let start_heigh = 135;

                if(index > 0)
                {
                    PDF_doc.addPage(1)
                    let total_page = PDF_doc.internal.getNumberOfPages()
                    PDF_doc.setPage(total_page)
                    start_heigh = 92;
                }

                PDF_doc.setFontSize(18)
                PDF_doc.setTextColor(70)

                let assignment_name = `${item.daily_assignment.number_assigment} - ${item.daily_assignment.description}`

                PDF_doc.setFont(undefined, 'bold')
                PDF_doc.setFontSize(13);
                let xOffsetSubTitle = (PDF_doc.internal.pageSize.width / 2) - (PDF_doc.getStringUnitWidth(assignment_name) * PDF_doc.internal.getFontSize() / 2); 
                PDF_doc.text(xOffsetSubTitle, start_heigh, assignment_name)

                PDF_doc.setFontSize(9);
                PDF_doc.text(40, start_heigh, `${this.report_root.day_of_today} assignments`)

                PDF_doc.setFont(undefined, 'normal')
                PDF_doc.setFontSize(10);
                PDF_doc.text(60, start_heigh + 25, `Associate Pager: ${(item.daily_assignment.associate_pager) ? item.daily_assignment.associate_pager : ''}`)

                PDF_doc.text(60, start_heigh + 45, `Supervisor Pager: ${(item.daily_assignment.supervisor_pager) ? item.daily_assignment.supervisor_pager : ''}`)

                PDF_doc.text(PDF_doc.internal.pageSize.width - 200, start_heigh + 55, `Last modified date: ${item.last_modified_date}`)

                autoTable(PDF_doc, {
                    columns: this.json_pdf_fields, 
                    body: item.rooms_assigned,
                    margin: { top: 100, bottom: 50 },
                    startY: start_heigh + 65
                })

                 // Simpler notes rendering
                const notes = item.daily_assignment.notes || '';
                const notes_x = 40;
                const notes_y = PDF_doc.lastAutoTable.finalY + 15;
                const max_width = PDF_doc.internal.pageSize.width - notes_x - 40;

                PDF_doc.setFont(undefined, 'bold');
                PDF_doc.setFontSize(10);
                PDF_doc.text('Notes:', notes_x, notes_y);

                PDF_doc.setFont(undefined, 'normal');
                // Split notes into lines to calculate height
                const notes_lines = PDF_doc.splitTextToSize(notes, max_width);
                const notes_text_x = notes_x + PDF_doc.getTextWidth('Notes: ');
                const notes_text_y = notes_y;
                PDF_doc.text(notes_lines, notes_text_x, notes_text_y);

                // Calculate the height of the notes block
                const lineHeight = PDF_doc.getLineHeight() / PDF_doc.internal.scaleFactor;
                const notes_block_height = notes_lines.length * lineHeight;
                const after_notes_y = notes_y + notes_block_height;

                autoTable(PDF_doc, {
                    columns: this.headers_step_codes_table, 
                    body: item.step_codes,
                    margin: { top: 100, bottom: 50 },
                    tableWidth: 350,
                    showHead: 'firstPage',
                    startY: after_notes_y + 10
                })

            })
           
            PDF_doc = this.addWaterMark(PDF_doc)

            PDF_doc.save(`${this.report_root.name} | ${this.report_root.daily_assignment_name}.pdf`)
        },

        async fill_data(data)
        {
            this.table_headers = []

            let main_title = ''
            let second_title = ''

            if(data.daily_assignments.length > 1)
            {
                main_title      = data.daily_assignments.length + ' daily assignments'
                second_title    = data.daily_assignments.length + ' daily assignments'
            }
            else 
            {
                main_title      = `${data.daily_assignments[0].daily_assignment.description}`
                second_title    =  `${data.daily_assignments[0].daily_assignment.number_assigment} - ${data.daily_assignments[0].daily_assignment.description }`
            }

            this.report_root = {
                title: `Assignments Quick Report - Associate View | ${main_title}`,
                name: `Associate Assignment`,
                daily_assignment_name: second_title,
                full_date: data.full_date,
                day_of_today: data.day_of_today

            }

            this.daily_assignments = data.daily_assignments
            this.title_page = this.report_root.title;
            this.logo_corporation = data.logo_corporation
        
            this.json_pdf_fields.forEach( (item, i) => {
                if(i === 0)
                {
                    this.table_headers.push({
                        text: item.title,
                        align: "start",
                        value: item.dataKey,
                    })
                }
                else
                {
                    this.table_headers.push({
                        text: item.title,
                        value: item.dataKey,
                    })
                }
            })

            this.loader()   
        },
        
        async apiLocalMethod(see_all_rooms = false)
        {
            if(this.hasPermissions(['Report Read']))
            {
                let daily_assignment_ids = JSON.parse(this.daily_assignment_id)

                if(Array.isArray(daily_assignment_ids) && daily_assignment_ids.length)
                {
                    const form_data = {
                        standard_report_id: this.parent_id,
                        daily_assignment_id: daily_assignment_ids,
                        see_all_rooms
                    }

                    this.loader(true)

                    const response = await this.post('search_standard_reports', form_data)

                    if(response.status)
                    {
                        this.fill_data(response.data)
                    }
                    else
                    {
                        this.error_handling(response)
                        this.loader(false)
                    }
                }
                else
                {
                    window.location = '/reports'
                }
            }
        }
    },

    watch: 
    {
        async 'see_all_rooms'(val)
        {
            this.apiLocalMethod(val)
        }

    },

    async mounted()
    {
        await this.apiLocalMethod(false)
        this.breadcrumb.push({
            name: this.report_root.title,
            href: this.current_url,
            arrow: '',
        })
    },

}
</script>
